import React, { useState } from "react";
import { Modal } from "antd/es";
import { RxCross1 } from "react-icons/rx";

// Safe parse utility
const safeParseArray = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
        try {
            return JSON.parse(value);
        } catch {
            try {
                return JSON.parse(value.replace(/'/g, '"'));
            } catch {
                console.warn("Failed to parse array string:", value);
                return [];
            }
        }
    }
    return [];
};

export default function FeatureChipsContainer({
    array,
    showOnly = false,
    name,
    handleEdit,
    setShowModal,
    heading,
    selected,
    setSelected,
    setArray,
    isDisable,
}) {
    // Safely parse selected
    if (!Array.isArray(selected)) {
        selected = safeParseArray(selected);
    }

    // Safely parse array
    if (!Array.isArray(array)) {
        array = safeParseArray(array);
    }

    const [isModalOpen, setIsModalOpen] = useState(false);

    const showOptionModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = (e) => {
        e.preventDefault();
        setIsModalOpen(false);
    };

    const onPressItem = (item) => {
        const parseSelected = Array.isArray(selected) ? [...selected] : safeParseArray(selected);
        const index = parseSelected.indexOf(item);

        if (index !== -1) {
            parseSelected.splice(index, 1);
        } else {
            parseSelected.push(item);
        }

        setSelected(parseSelected);
    };

    const visibleItems = showOnly ? array : Array.from(new Set([...array.slice(0, 6), ...(selected || [])]));

    return (
        <div className={`${!showOnly && "tw-mt-5"}`}>
            <Modal
                title={
                    <div className="tw-flex tw-items-center tw-justify-between tw-pr-4">
                        <span className="tw-text-[20px] tw-font-semibold tw-text-[#333333]">{heading || "Select Options"}</span>
                    </div>
                }
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                centered
                width={600}
                closeIcon={<RxCross1 className="tw-text-[18px] tw-text-[#606060] hover:tw-text-primary tw-transition-colors" />}
                className="feature-chips-modal"
                styles={{
                    body: { padding: "24px", maxHeight: "60vh", overflowY: "auto" },
                    header: { padding: "20px 24px", borderBottom: "1px solid #ECECEC" },
                    footer: { padding: "16px 24px", borderTop: "1px solid #ECECEC" },
                }}
                okText="Done"
                cancelText="Cancel"
                okButtonProps={{
                    className: "tw-bg-primary hover:tw-bg-primary_hover tw-border-primary tw-h-[42px] tw-px-6 tw-rounded-lg tw-font-medium tw-transition-all tw-shadow-sm hover:tw-shadow-md",
                }}
                cancelButtonProps={{
                    className: "tw-h-[42px] tw-px-6 tw-rounded-lg tw-font-medium tw-border-[#ECECEC] tw-text-[#606060] hover:tw-border-primary hover:tw-text-primary tw-transition-all",
                }}
            >
                <div className="tw-flex tw-flex-wrap tw-gap-3 tw-items-start tw-justify-start tw-py-2">
                    {array?.map((item, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                handleEdit(name);
                                if (!isDisable) onPressItem(item);
                            }}
                            className={`${
                                selected?.includes(item)
                                    ? "tw-text-white tw-bg-primary tw-border-primary tw-shadow-md"
                                    : "tw-text-[#606060] tw-bg-white hover:tw-border-primary hover:tw-text-primary"
                            } tw-h-[42px] tw-rounded-lg tw-border tw-border-[#ECECEC] tw-px-4 tw-text-[15px] tw-font-medium tw-flex tw-items-center tw-transition-all tw-duration-200 hover:tw-shadow-sm tw-cursor-pointer`}
                        >
                            {item}
                        </button>
                    ))}
                </div>
            </Modal>

            {!showOnly && <p className="tw-text-[#333333] tw-font-[600] tw-text-[18px]">{heading}</p>}

            <div className="tw-py-3 tw-flex tw-flex-wrap tw-gap-3 tw-mt-3">
                {visibleItems.map((item, index) => (
                    <button
                        key={index}
                        onClick={() => {
                            if (!showOnly) handleEdit(name);
                            if (!isDisable) onPressItem(item);
                        }}
                        className={`${
                            selected?.includes(item) ? "tw-text-white tw-bg-primary tw-border-primary" : "tw-text-[#606060] tw-bg-white"
                        } tw-h-[38px] md:tw-h-[42px] tw-rounded-[8px] tw-border tw-border-[#ECECEC] tw-px-1 md:tw-px-3 tw-text-[12px] md:tw-text-[16px] tw-flex tw-items-center`}
                    >
                        {item}
                    </button>
                ))}

                {!showOnly && array?.length > 6 && (
                    <button
                        onClick={showOptionModal}
                        className="tw-text-primary tw-border-primary tw-border tw-h-[42px] tw-rounded-[8px] tw-px-3 tw-text-[16px] tw-bg-white tw-flex tw-items-center"
                    >
                        + add more
                    </button>
                )}
            </div>
        </div>
    );
}
